import type { SubprocessOption } from "../select/SubprocessCells";

export const UNKNOWN_PROCESS_GROUP = "__unknown__";

/** The shared process-group order for OS and RN Размерување views. */
export const buildProcessGroupOrder = (subprocesses: SubprocessOption[]): string[] => {
  const seen = new Map<string, { order?: number; name?: string }>();
  subprocesses.forEach((sp) => {
    const pd = sp.processDefinition;
    if (pd && typeof pd === "object" && pd._id && !seen.has(pd._id)) {
      seen.set(pd._id, { order: pd.order, name: pd.name });
    }
  });
  return Array.from(seen.entries())
    .sort(([, a], [, b]) => {
      if (a.order != null && b.order != null && a.order !== b.order) return a.order - b.order;
      if (a.order != null && b.order == null) return -1;
      if (a.order == null && b.order != null) return 1;
      return (a.name || "").localeCompare(b.name || "", "mk");
    })
    .map(([id]) => id);
};

export const processGroupIdForSubprocess = (
  subprocessId: string,
  subprocessesById: Map<string, SubprocessOption>
): string => {
  const pd = subprocessesById.get(subprocessId)?.processDefinition;
  return pd && typeof pd === "object" && pd._id ? pd._id : UNKNOWN_PROCESS_GROUP;
};

export const processGroupRank = (processGroupId: string, processGroupOrder: string[]): number => {
  const index = processGroupOrder.indexOf(processGroupId);
  return index === -1 ? processGroupOrder.length : index;
};
